module.exports = __webpack_public_path__ + "img/youtube.54b9b29a.png";